import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuestionIndex from './QuestionIndex';
import { isCalculatorAllowed } from '../utility/Utils';
import CalculatorAllowedIconButton from './CalculatorAllowedIconButton';
import './QuestionInfo.scss';

/**
 * Renders question info
 * */
class QuestionInfo extends PureComponent {
  static displayName = 'QuestionInfo';

  static propTypes = {
    allowCalculatorForItems: PropTypes.array.isRequired,
    showCalculatorAllowedIcon: PropTypes.bool,
    showQuestionIndex: PropTypes.bool,
    isImpersonating: PropTypes.bool,
  };

  static defaultProps = {
    showCalculatorAllowedIcon: true,
    showQuestionIndex: true,
    isImpersonating: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentItemIndex: -1,
      currentItemReference: null,
      shouldAllowCalculator: false,
    };

    this.readyListener = this.readyListener.bind(this);
  }

  componentDidMount() {
    this.readyListener();
  }

  /**
   * Init method
   * */
  readyListener() {
    const {
      learnosityData: { items, app },
      allowCalculatorForItems,
    } = this.props;
    /*
     * We need to use `getCurrentItem()` because when resizing this.props.learnosityData.currentItem will point to
     * the original opened item.
     * */
    const { reference } = app.getCurrentItem();

    app.on('item:changed', this.itemChanged.bind(this));

    this.setState({
      currentItemReference: reference,
      currentItemIndex: Object.keys(items).indexOf(reference) + 1,
      shouldAllowCalculator: isCalculatorAllowed(
        allowCalculatorForItems,
        reference,
      ),
    });
  }

  /**
   * Learnosity Event handler for when item has changed
   * @param {number} itemIndex The item index
   * */
  itemChanged(itemIndex) {
    const {
      learnosityData: { app },
      allowCalculatorForItems,
    } = this.props;
    const { reference } = app.getCurrentItem();

    this.setState({
      currentItemReference: reference,
      currentItemIndex: itemIndex + 1,
      shouldAllowCalculator: isCalculatorAllowed(
        allowCalculatorForItems,
        reference,
      ),
    });
  }

  render() {
    const { currentItemReference, currentItemIndex, shouldAllowCalculator } =
      this.state;

    if (!currentItemReference) {
      return null;
    }

    const { showQuestionIndex, showCalculatorAllowedIcon } = this.props;

    return (
      <Fragment>
        {showQuestionIndex && <QuestionIndex index={currentItemIndex} />}
        {showCalculatorAllowedIcon && shouldAllowCalculator && (
          <CalculatorAllowedIconButton />
        )}
      </Fragment>
    );
  }
}

export default QuestionInfo;
